import InterlinkingJobs from '.';

const InterlinkingJobsContainer = InterlinkingJobs;

InterlinkingJobsContainer.displayName = 'InterlinkingJobsContainer';

export default InterlinkingJobsContainer;



// WEBPACK FOOTER //
// ./app/Serp/components/Interlinking/jobs/container.js